import React, { useState, useImperativeHandle, useRef, ReactNode } from "react";
import {
  Input,
  Text,
  Icon,
  Pressable,
  Box,
  Button,
  AlertDialog,
  View,
  WarningTwoIcon,
} from "native-base";
import { RFPercentage } from "react-native-responsive-fontsize";
import Modal from "react-native-modal";
import { TouchableOpacity, View as RNView } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTheme } from "../../ThemeProvider";

interface BotoesRodapeProps {
  onConfirmNegativo?: () => void;
  onConfirmPositivo?: (dados?: any) => void;
  titulo?: string;
  mensagem?: string;
  textoBotaoNegativo?: string;
  textoBotaoPositivo?: string;
  fecharModal?: () => void;
  children?: ReactNode;
  capturarDados?: () => any;
  semBotaoFechar?: boolean;
  semBotoes?: boolean;
}

function ModalConfirmacao(
  {
    titulo,
    mensagem,
    textoBotaoNegativo,
    textoBotaoPositivo,
    onConfirmNegativo,
    onConfirmPositivo,
    children,
    capturarDados,
    semBotaoFechar,
    semBotoes,
  }: BotoesRodapeProps,
  ref: any,
) {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { isMobile, fontSizeMobile, fontSizeDesktop, configEmpresa } =
    useTheme();

  // antes de fazer o json.parse, verificar se o configEmpresa é um objeto

  let backgroundColor = "#fff";
  let corTexto = "#000";
  let corBorda = "#000";

  if (typeof configEmpresa === "string") {
    const coresPWA = JSON.parse(configEmpresa).coresPWA;
    backgroundColor = coresPWA?.corFundoModal;
    corTexto = coresPWA?.corFontePrimaria;
    corBorda = coresPWA?.corBordaPrimaria;
  }
  const cancelRef = useRef<any>(null);

  function abrirModal() {
    setModalVisible(true);
  }

  function fecharModal() {
    setModalVisible(false);
  }

  function handleConfirmarPositivo() {
    const dados = capturarDados ? capturarDados() : null;
    onConfirmPositivo?.(dados);
  }

  useImperativeHandle(ref, () => ({ abrirModal, fecharModal }));

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={modalVisible}
      onClose={() => fecharModal()}
    >
      <AlertDialog.Content borderColor={corBorda}>
        {!semBotaoFechar && <AlertDialog.CloseButton />}
        <AlertDialog.Header
          backgroundColor={backgroundColor}
          color={corTexto}
          style={{ borderColor: corBorda }}
        >
          <Text style={{ color: corTexto }} fontSize="xl">
            <WarningTwoIcon /> <b>{titulo}</b>
          </Text>
        </AlertDialog.Header>
        <AlertDialog.Body backgroundColor={backgroundColor}>
          {mensagem && (
            <Text style={{ color: corTexto }} fontSize="md" textAlign="center">
              {mensagem}
            </Text>
          )}
          {children && (
            <Box style={{ marginTop: mensagem ? 10 : 0 }}>{children}</Box>
          )}
        </AlertDialog.Body>
        {!semBotoes && (
          <AlertDialog.Footer
            backgroundColor={backgroundColor}
            style={{ borderColor: corBorda }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {textoBotaoNegativo && (
                <TouchableOpacity
                  onPress={() => {
                    if (onConfirmNegativo) {
                      onConfirmNegativo();
                    }
                  }}
                  style={{
                    backgroundColor: "red",
                    paddingVertical: 10,
                    paddingHorizontal: 14,
                    borderRadius: 8,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RNView
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <MaterialCommunityIcons
                      name="close-circle-outline"
                      size={22}
                      color="#fff"
                      style={{ marginRight: 8 }}
                    />
                    <Text
                      style={{
                        color: "#fff",
                      }}
                      fontSize="md"
                    >
                      {textoBotaoNegativo}
                    </Text>
                  </RNView>
                </TouchableOpacity>
              )}

              <TouchableOpacity
                onPress={handleConfirmarPositivo}
                style={{
                  backgroundColor: "green",
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  borderRadius: 8,
                  marginLeft: 5,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <RNView
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <MaterialCommunityIcons
                    name="check-circle-outline"
                    size={22}
                    color="#fff"
                    style={{ marginRight: 8 }}
                  />
                  <Text
                    style={{
                      color: "#fff",
                    }}
                    fontSize="md"
                  >
                    {textoBotaoPositivo}
                  </Text>
                </RNView>
              </TouchableOpacity>
            </View>
          </AlertDialog.Footer>
        )}
      </AlertDialog.Content>
    </AlertDialog>
  );
}

export default React.forwardRef(ModalConfirmacao);
